module.exports = __webpack_public_path__ + "img/MR.0a8e4de8.svg";